// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__CGuYO","iconsBlock":"styles_iconsBlock__3ehjF"};